import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a68064f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full px-4 my-3" }
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = {
  key: 0,
  class: "material-icons pr-2 h-full my-auto w-12",
  style: {"padding-left":"14px"}
}
const _hoisted_4 = {
  key: 1,
  class: "material-icons pr-2 h-full my-auto w-12",
  style: {"padding-left":"14px"}
}
const _hoisted_5 = { class: "w-full grid grid-cols-6" }
const _hoisted_6 = { class: "pl-4 pr-2 py-3" }
const _hoisted_7 = { class: "px-2 py-3" }
const _hoisted_8 = {
  class: "items-center justify-center px-2 py-2",
  style: {"padding-top":"10px"}
}
const _hoisted_9 = { class: "px-2 py-3" }
const _hoisted_10 = { class: "px-2 py-3 col-span-2" }
const _hoisted_11 = {
  key: 0,
  class: "border shadow-md flex justify-center items-center border-primary-50 dark:border-dark-400",
  style: {"height":"120px","border-bottom-left-radius":"0.5rem","border-bottom-right-radius":"0.5rem"}
}
const _hoisted_12 = {
  key: 0,
  class: "px-4 py-3"
}
const _hoisted_13 = {
  key: 1,
  class: "w-full flex"
}
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons text-sm pr-2 my-auto py-3 w-12",
  style: {"padding-left":"18px"}
}, " subdirectory_arrow_right ", -1))
const _hoisted_17 = { class: "px-2 py-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons text-sm pr-2 py-3 w-12",
  style: {"padding-left":"18px"}
}, " subdirectory_arrow_right ", -1))
const _hoisted_19 = { class: "w-full grid grid-cols-5" }
const _hoisted_20 = { class: "px-2 py-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_23 = { class: "px-2 py-3 col-span-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons py-3 pl-4" }, "add_circle", -1))
const _hoisted_25 = { class: "px-2 my-auto" }
const _hoisted_26 = {
  key: 0,
  style: {"width":"240%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JudgeBadge = _resolveComponent("JudgeBadge")!
  const _component_LoadingPanel = _resolveComponent("LoadingPanel")!
  const _component_ReviewEditorPanel = _resolveComponent("ReviewEditorPanel")!
  const _component_ReviewDetailPanel = _resolveComponent("ReviewDetailPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex cursor-pointer", {
          'bg-primary-400 hover:bg-primary-300 text-white dark:bg-dark-400 dark:hover:bg-dark-300 rounded-top dark:text-dark-text':
            _ctx.reviewPostPageStatePresenter.isSummaryExpanded(_ctx.entryId).value,
          'rounded-all hover:bg-gray-100 dark:hover:bg-dark-500':
            !_ctx.reviewPostPageStatePresenter.isSummaryExpanded(_ctx.entryId).value
        }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickEntrySummary(_ctx.entryId)))
      }, [
        (_ctx.reviewPostPageStatePresenter.isSummaryExpanded(_ctx.entryId).value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " arrow_drop_up "))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, " arrow_drop_down ")),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.entry.judgeId), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.entry.userId), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_JudgeBadge, {
              status: _ctx.entry.status
            }, null, 8, ["status"])
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.entry.language), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.timestampToDate(_ctx.entry.entryDate)), 1)
        ])
      ], 2),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_LoadingPanel)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass({
          'rounded-bottom border shadow-md border-primary-50 dark:border-dark-400':
            _ctx.reviewPostPageStatePresenter.isSummaryExpanded(_ctx.entryId).value
        })
      }, [
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              (!_ctx.hasEntryDetailInList(_ctx.entryId))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('message.noData')), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewEntryDetailList[_ctx.entryId], (detail, detailIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: detailIndex,
                          onClick: ($event: any) => (_ctx.reviewPostPageStatePresenter.setEntrySelectedReviewIndex(_ctx.entryId, detailIndex))
                        }, [
                          _createVNode(_Transition, { name: "left-slide-fade" }, {
                            default: _withCtx(() => [
                              (
                        _ctx.reviewPostPageStatePresenter.isDetailSelected(_ctx.entryId).value ||
                        _ctx.reviewPostPageStatePresenter.entryEditingList.value[_ctx.entryId]
                      )
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["flex cursor-pointer my-3 ml-3", {
                        'bg-primary-50 dark:bg-dark-400':
                          _ctx.reviewPostPageStatePresenter.entrySelectedReviewIndexList.value[_ctx.entryId] === detailIndex,
                        'hover:bg-gray-100 dark:hover:bg-dark-500':
                          _ctx.reviewPostPageStatePresenter.entrySelectedReviewIndexList.value[_ctx.entryId] !== detailIndex
                      }]),
                                    style: _normalizeStyle([{"border-radius":"0.5rem"}, { '--delay': `${detailIndex * 100 + 100}ms` }])
                                  }, [
                                    _hoisted_16,
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_17, _toDisplayString(detail.reviewerId), 1)
                                    ])
                                  ], 6))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_Transition, { name: "left-slide-fade" }, {
                            default: _withCtx(() => [
                              (
                        !_ctx.reviewPostPageStatePresenter.isDetailSelected(_ctx.entryId).value &&
                        !_ctx.reviewPostPageStatePresenter.entryEditingList.value[_ctx.entryId]
                      )
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "flex cursor-pointer my-3 mx-2 hover:bg-gray-100 dark:hover:bg-dark-500",
                                    style: _normalizeStyle([{"border-radius":"0.5rem"}, { '--delay': `${detailIndex * 100 + 100}ms` }])
                                  }, [
                                    _hoisted_18,
                                    _createElementVNode("div", _hoisted_19, [
                                      _createElementVNode("div", _hoisted_20, _toDisplayString(detail.reviewerId), 1),
                                      _hoisted_21,
                                      _hoisted_22,
                                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.timestampToDate(detail.reviewDate as any)), 1)
                                    ])
                                  ], 4))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ], 8, _hoisted_15))
                      }), 128)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["my-3 ml-3 flex items-start justify-start", {
                    'mx-2':
                      !_ctx.reviewPostPageStatePresenter.isDetailSelected(_ctx.entryId).value &&
                      !_ctx.reviewPostPageStatePresenter.entryEditingList.value[_ctx.entryId],
                    'bg-primary-50 dark:bg-dark-400': _ctx.reviewPostPageStatePresenter.entryEditingList.value[_ctx.entryId],
                    'hover:bg-gray-100 dark:hover:bg-dark-500':
                      !_ctx.reviewPostPageStatePresenter.entryEditingList.value[_ctx.entryId]
                  }]),
                        style: {"border-radius":"0.5rem"}
                      }, [
                        _createElementVNode("button", {
                          class: "w-full flex items-start justify-start focus:outline-none",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reviewPostPageStatePresenter.reverseEntryEditingFlag(_ctx.entryId)))
                        }, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('message.newReviewSubmit')), 1)
                        ])
                      ], 2)
                    ]),
                    _createVNode(_Transition, { name: "left-slide-fade" }, {
                      default: _withCtx(() => [
                        (
                    _ctx.reviewPostPageStatePresenter.isDetailSelected(_ctx.entryId).value ||
                    _ctx.reviewPostPageStatePresenter.entryEditingList.value[_ctx.entryId]
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              (_ctx.reviewPostPageStatePresenter.entryEditingList.value[_ctx.entryId])
                                ? (_openBlock(), _createBlock(_component_ReviewEditorPanel, {
                                    key: 0,
                                    entry: _ctx.entry,
                                    entryId: _ctx.entryId,
                                    isDarkMode: {}
                                  }, null, 8, ["entry", "entryId"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ReviewDetailPanel, {
                                entryId: _ctx.entryId,
                                entryType: _ctx.entryType,
                                index: _ctx.index
                              }, null, 8, ["entryId", "entryType", "index"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]))
            ], 512), [
              [_vShow, _ctx.reviewPostPageStatePresenter.isSummaryExpanded(_ctx.entryId).value]
            ])
          ]),
          _: 1
        })
      ], 2), [
        [_vShow, !_ctx.isLoading]
      ])
    ])
  ]))
}